module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-ES.0cf58b0.webp";